<template>
  <div>
      <header>
          <div class="headerOne">
               <i class="el-icon-arrow-left" @click="gocardBag"></i>
               <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
                <span class="buss">{{msg}}</span>
          </div>
      </header>
       <div id="zhangwei"></div>
      <div>
          <ul class="ulTwo" v-if="haveMessage">
              <li v-for="(item,index) in redaArr" :key="index" @click="godetailOne(item.msgId)" > 
                  <div class="one">
                      <span style="margin-left:0.35rem;font-weight:bold">{{item.subject}}</span>
                        <img src="../../assets/images/goOn.png" alt="" class="goTo">
                     <div class="blueQuan" v-if="item.isRead==0?true:false"></div>
                      <div class="ceontrn">
                            <span class="teo">{{item.sendTime}}</span>
                           
                      </div>   
                    </div>

                
                  <div class="content" > 
                </div>
              </li>
           
          </ul>
          <ul v-if="!haveMessage">
              <li class="message">暂无任何消息</li>
          </ul>        
      </div>
  </div>
</template>
<script>
import axios from "axios"
import { Popup ,Toast } from 'mint-ui';

    export default{
        data(){
            return{
                blueTyr:true,
                redaArr:[],
                msg:"消息中心",
                text:"【消息】亲爱的王晓玥你好,你在我小店",
                haveMessage:true,
                Toast: Toast({
                    message: '加载中...',
                    position: 'middle',
                    duration: -1
                    }),
                }
        },
        computed:{
             wsWbsocket(){
             return this.$store.state.wsWbsocket
         }
        },
        methods:{
            gocardBag(){
                this.$router.push({
                path:"/cardBag",
            }) 
            },
            checkHttpReturn(id)
               {
                if(httpSendQue[id]==0)
                {
                    var  self=this;
                    setTimeout(() => {
                            if (self && !self._isDestroyed)
                                self.checkHttpTimeOut();
                        }, newConfigTime);

                }
                else
                {
                    delete httpSendQue[id];
                }
            },
            checkHttpTimeOut()
                {
                    if(httpSendQue[id]==0)
                    {
                        //  隐藏加载中
                        this.Toast.close()
                        Toast({
                                message: '网络不给力',
                                position: 'middle',
                                duration: 3000
                            })
                        

                    }
                    else
                    {
                        //删除数组中的id
                        delete httpSendQue[id];

                    }
            },
             getWebsocket(){
                var  self=this;     
                id= getHttpSendId ();
                getArry(id)   //将生成ID放入数组  
                setTimeout(() => 
                {
                    if (self && !self._isDestroyed)
                        self.checkHttpReturn(id);
                }, configTime);      
                axios.get(getInformation+"&uid="+uid+"&sign="+sign+"&mode="+mode+"&beginIdx="+0+"&maxRows="+200)
                .then(res=>{  
                    console.log(res)
                 httpSendQue[id] = 1; 
                 this.Toast.close();
                if(res.data.s==0){
                     this.haveMessage=true
                    this.redaArr=res.data.MessageList   
                    this.$store.commit("MessageList",res.data.MessageList )    
                }else if(res.data.s==1010){
                     this.haveMessage=false
                }
                    })
                .catch(error=>{
                   httpSendQue[id] = 1;   
                      this.Toast.close()
                         Toast({
                              message: '网络不给力',
                              position: 'middle',
                              duration:2000
                            })                
                            })
             },
 
            godetailOne(isReadOne){
              console.log()
              this.$router.push({
                  path:"/detailOne",
                  query:{
                      isRead:isReadOne
                  }
              })
            }
        },
        created(){
             this.Toast
          this.redaArr=this.$store.state.MessageList
        },
        mounted(){
          this.getWebsocket()
        },
        destroyed()
        {
            this.Toast.close()
        
        }
        
    }
</script>
<style scoped> 
.message{
    color: rgba(0, 0,0, 0.5);
    font-size: 0.55rem;
    text-align: center;
    margin-top: 6rem
}
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header{
    height:1.6rem;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
    position: fixed;
    top: 0;
    background: white
}
#zhangwei {
  height: 1.6rem;
  width: 100%;
  background: white
}
 .headerOne{
     font-size: 0;  
      background: white
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
   .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
  .blueQuan{
      height: 0.2rem;
      width: 0.2rem;
      border-radius: 50%;
      background: #67B2Fd; 
      /* position: absolute;
       top: 0.88rem */
  }
  .ceontrn{
     padding-left: 0.32rem;
  }
    .ulTwo li {
        /* position: relative; */
        font-size: 0;
        width: 95%;
        margin: 0.1rem auto ;
        height:1.8rem;
        /* margin: 0.6rem 0 0.5rem  0.5rem; */
          border-bottom: 1px solid rgba(0, 0,0, 0.2);
    }
  .ulTwo li .one{
      color: #c80000;
      font-size: 0.55rem;
      padding-top: 0.2rem;
  }
  .ulTwo li .teo{
      color: rgba(0, 0,0, 0.2);
      font-size: 0.45rem;
    
  }
  .ulTwo li .three{
      color: rgba(0, 0, 0, 0.9);
      font-size: 0.38rem;
      display: block;
      margin: 0 auto;
      /* text-align: center */
      border: none;
      width: 7rem;
      overflow: hidden;
      line-height: 1rem;
      margin-bottom: 0.2rem;
     text-overflow: ellipsis;
     margin: 0;
     padding-left: 0.2rem

  }
  .five{
      color: rgba(0, 0, 0, 0.9);
      font-size: 0.34rem;
      vertical-align: middle;
  }
  .content{
     text-align: center;
     margin-top: 0.3rem;
     padding-bottom: 0.4rem
  }
   .ulTwo li img{
       width: 0.4rem;
       height: auto;
        display: block;
        float: right;
        margin-top: 0.35rem;
        margin-right: 0.45rem
   }
 </style>



// WEBPACK FOOTER //
// src/components/change/informationOne.vue